export default "__VITE_ASSET__DQOzpFZx__"